/* ============================================================
   FEMBE SUBSCRIPTION WIDGET  ·  <fembe-subscription>
   Einmalkauf vs. Spar-Abo + dynamische Intervall-Auswahl.
   - selling_plan robust über 'formdata'-Event (alle Cart-Formulare)
     + gespiegelte Hidden-Inputs (Express-Checkout). KEIN fetch-Override.
   - Intervall koppelt automatisch an Pack-Reichweite (Conversion).
   - Teilt window.cvState + Event 'cv:type-changed' mit Variant-Cards.
   ============================================================ */
(function () {
  'use strict';
  if (window.customElements && customElements.get('fembe-subscription')) return;

  function eur(cents) {
    if (!isFinite(cents)) cents = 0;
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  /* selling_plan in JEDE Add-to-Cart-FormData schreiben (AJAX, beide Formulare). */
  function installFormDataHook() {
    if (window.__cvSellingPlanHook) return;
    window.__cvSellingPlanHook = true;
    document.addEventListener('formdata', function (e) {
      var f = e.target;
      if (!f || !f.action || String(f.action).indexOf('/cart/add') === -1) return;
      var st = window.cvState || {};
      /* Nur das Formular DIESES Produkts anfassen (nicht Quick-Add anderer Produkte). */
      var idField = f.querySelector('[name="id"]');
      var vid = idField ? String(idField.value) : null;
      if (!st.variantIds || !vid || st.variantIds.indexOf(vid) === -1) return;
      if (st.type === 'subscription' && st.planId) e.formData.set('selling_plan', String(st.planId));
      else e.formData.delete('selling_plan');
    });
  }

  class FembeSubscription extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      var dataEl = this.querySelector('[data-cv-data]');
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { this.data = { variants: {}, plans: [] }; }
      this.variants = this.data.variants || {};
      this.plans = (this.data.plans || []).map(function (p) {
        return {
          id: String(p.id),
          name: p.name || '',
          months: parseIntervalMonths(p),
          adj: firstAdjustment(p)
        };
      });
      this.selectedId = this.data.selectedId ? String(this.data.selectedId) : null;

      installFormDataHook();

      /* Typ aus geteiltem State übernehmen (überlebt HTML-Swaps), sonst Abo. */
      var prev = window.cvState || {};
      this.type = prev.type === 'onetime' ? 'onetime' : 'subscription';
      this.manualInterval = false;
      this.planId = this._defaultPlanId(this._currentVariant());

      /* Events */
      this._onTypeChange = this._onTypeChange.bind(this);
      this._onPillClick = this._onPillClick.bind(this);
      this._onVariantChange = this._onVariantChange.bind(this);
      this.querySelectorAll('[data-cv-type]').forEach((r) => r.addEventListener('change', this._onTypeChange));
      this.querySelectorAll('.cv-interval').forEach((b) => b.addEventListener('click', this._onPillClick));
      document.addEventListener('variant:change', this._onVariantChange);

      this._applyTypeUI();
      this._render();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChange);
    }

    /* ── Varianten-Auflösung ── */
    _currentVariant() {
      var id = null;
      try { var u = new URLSearchParams(window.location.search).get('variant'); if (u && this.variants[u]) id = u; } catch (e) {}
      if (!id) {
        var input = document.querySelector('product-info input[name="id"], form[action*="/cart/add"] [name="id"]');
        if (input && this.variants[input.value]) id = String(input.value);
      }
      if (!id && this.selectedId && this.variants[this.selectedId]) id = this.selectedId;
      if (!id) { for (var k in this.variants) { id = k; break; } }
      var v = this.variants[id];
      return v ? { id: id, price: Number(v.price) || 0, reichweite: Number(v.reichweite) || 0, items: Number(v.items) || 0, tagesdosis: Number(v.tagesdosis) || 1 } : null;
    }

    _planById(id) {
      for (var i = 0; i < this.plans.length; i++) if (this.plans[i].id === String(id)) return this.plans[i];
      return this.plans[0] || null;
    }

    /* Plan, dessen Intervall am besten zur Pack-Reichweite passt (sonst höchster Rabatt). */
    _defaultPlanId(variant) {
      if (!this.plans.length) return null;
      var months = variant && variant.reichweite > 0 ? Math.max(1, Math.round(variant.reichweite / 30)) : 0;
      var base = variant ? variant.price : 1000;
      var self = this;
      var sorted = this.plans.slice().sort(function (a, b) {
        if (months > 0) {
          var da = Math.abs(a.months - months), db = Math.abs(b.months - months);
          if (da !== db) return da - db;
        }
        return self._savePct(base, b) - self._savePct(base, a);
      });
      return sorted[0].id;
    }

    _aboPrice(base, plan) {
      if (!plan || !plan.adj) return base;
      var a = plan.adj;
      if (a.type === 'percentage') return Math.round(base * (1 - a.value / 100));
      if (a.type === 'fixed_amount') return Math.max(0, base - a.value);
      if (a.type === 'price') return a.value;
      return base;
    }
    _savePct(base, plan) {
      if (!base) return 0;
      var abo = this._aboPrice(base, plan);
      return Math.round(((base - abo) / base) * 100);
    }
    _perDay(price, v) {
      var r = v.reichweite, it = v.items, dose = v.tagesdosis || 1;
      if (dose <= 0) dose = 1;
      if (r > 0) return price / r;
      if (it > 0) return (price * dose) / it;
      return price / 30;
    }

    /* ── Events ── */
    _onTypeChange(e) {
      this.type = e.target.value === 'onetime' ? 'onetime' : 'subscription';
      this._applyTypeUI();
      this._render();
    }
    _onPillClick(e) {
      var btn = e.currentTarget;
      this.planId = String(btn.dataset.planId);
      this.manualInterval = true;
      this.type = 'subscription';
      var aboRadio = this.querySelector('[data-cv-type][value="subscription"]');
      if (aboRadio) aboRadio.checked = true;
      this._applyTypeUI();
      this._render();
    }
    _onVariantChange() {
      if (!this.isConnected) { document.removeEventListener('variant:change', this._onVariantChange); return; }
      /* Pack gewechselt -> Intervall neu an Reichweite koppeln (Manual zurücksetzen). */
      this.manualInterval = false;
      this.planId = this._defaultPlanId(this._currentVariant());
      this._render();
    }

    _applyTypeUI() {
      var self = this;
      this.querySelectorAll('.cv-card').forEach((c) => c.classList.toggle('cv-active', c.dataset.type === self.type));
      /* Radio-Status mit sichtbarem Zustand synchron halten (überlebt HTML-Swaps). */
      this.querySelectorAll('[data-cv-type]').forEach((r) => { r.checked = (r.value === self.type); });
    }

    /* ── Render ── */
    _render() {
      if (!this.isConnected) return; /* nach HTML-Swap nicht auf altem Knoten rendern */
      var variant = this._currentVariant();
      if (!variant) return;
      if (!this.manualInterval) this.planId = this._defaultPlanId(variant);
      var plan = this._planById(this.planId);

      var once = variant.price;
      var abo = plan ? this._aboPrice(once, plan) : once;
      var savePct = plan ? this._savePct(once, plan) : 0;
      var saveAbs = once - abo;

      var set = (sel, txt) => { var el = this.querySelector(sel); if (el) el.textContent = txt; };
      /* Tagesdosis-Preis nur zeigen, wenn echte Dosierungs-Daten vorhanden. */
      var hasDose = variant.reichweite > 0 || variant.items > 0;

      /* Einmalkauf */
      set('[data-cv-once-price]', eur(once));
      set('[data-cv-once-unit]', hasDose ? this._perUnitLabel(this._perDay(once, variant)) : '');

      /* Abo */
      set('[data-cv-abo-price]', eur(abo));
      var oldEl = this.querySelector('[data-cv-abo-old]');
      if (oldEl) { oldEl.textContent = abo < once ? eur(once) : ''; }
      set('[data-cv-abo-unit]', hasDose ? this._perUnitLabel(this._perDay(abo, variant)) : '');

      var pill = this.querySelector('[data-cv-save-pill]');
      if (pill) {
        if (savePct >= 1) { pill.hidden = false; set('[data-cv-save-text]', savePct + '% sparen – ' + eur(saveAbs) + ' günstiger'); }
        else { pill.hidden = true; }
      }

      /* Intervall-Note im Titel + Pills */
      set('[data-cv-interval-note]', plan ? '– ' + this._cleanInterval(plan) : '');
      this._renderPills(once);

      /* Geteilter State + Sync */
      var adj = plan && plan.adj ? plan.adj : { type: 'percentage', value: 0 };
      window.cvState = {
        type: this.type,
        planId: this.type === 'subscription' ? this.planId : null,
        discountType: adj.type,
        discountValue: adj.value,
        variantIds: Object.keys(this.variants)
      };
      this._syncSellingPlanInputs();
      document.dispatchEvent(new CustomEvent('cv:type-changed', { detail: { type: this.type, planId: this.planId } }));
    }

    _perUnitLabel(perDayCents) {
      return 'nur ' + eur(Math.round(perDayCents)) + ' / Tagesdosis';
    }

    _renderPills(basePrice) {
      var self = this;
      var pills = this.querySelectorAll('.cv-interval');
      var multi = this.plans.length > 1;
      pills.forEach(function (btn) {
        var id = String(btn.dataset.planId);
        var plan = self._planById(id);
        btn.classList.toggle('cv-interval--active', id === String(self.planId) && self.type === 'subscription');
        btn.classList.toggle('cv-interval--single', !multi);
        var label = btn.querySelector('.cv-interval__text');
        if (label && plan) label.textContent = self._cleanInterval(plan);
        var saveEl = btn.querySelector('[data-cv-interval-save]');
        if (saveEl && plan) {
          var pct = self._savePct(basePrice, plan);
          saveEl.textContent = pct >= 1 ? '−' + pct + ' %' : '';
        }
      });
    }

    _cleanInterval(plan) {
      var m = plan.months;
      if (m <= 1) return 'monatlich';
      return 'alle ' + m + ' Monate';
    }

    /* selling_plan-Hidden-Input je Cart-Formular spiegeln (Express-Checkout). */
    _syncSellingPlanInputs() {
      var self = this;
      var st = window.cvState || {};
      var sub = st.type === 'subscription' && st.planId;
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
        /* Nur Formulare DIESES Produkts (nicht Quick-Add anderer Produkte). */
        var idField = f.querySelector('[name="id"]');
        var vid = idField ? String(idField.value) : null;
        if (!vid || !self.variants[vid]) return;
        var inp = f.querySelector('input[data-cv-selling-plan]');
        if (sub) {
          if (!inp) {
            inp = document.createElement('input');
            inp.type = 'hidden';
            inp.name = 'selling_plan';
            inp.setAttribute('data-cv-selling-plan', '');
            f.appendChild(inp);
          }
          inp.value = String(st.planId);
          inp.disabled = false;
        } else if (inp) {
          inp.parentNode.removeChild(inp);
        }
      });
    }
  }

  /* ── Helpers ── */
  function firstAdjustment(plan) {
    var arr = plan.price_adjustments || [];
    if (!arr.length) return { type: 'percentage', value: 0 };
    var a = arr[0];
    return { type: a.value_type || 'percentage', value: Number(a.value) || 0 };
  }
  function parseIntervalMonths(plan) {
    var s = (plan.name || '').toLowerCase();
    if (plan.options && plan.options.length) {
      plan.options.forEach(function (o) {
        if (o && typeof o === 'object' && o.value) s += ' ' + String(o.value).toLowerCase();
        else if (typeof o === 'string') s += ' ' + o.toLowerCase();
      });
    }
    /* Spezielle deutsche Begriffe zuerst. */
    if (/vierteljähr|quarter/.test(s)) return 3;
    if (/halbjähr|semi-?annual|biannual/.test(s)) return 6;
    /* Zahl möglichst DIREKT an der Einheit lesen (ignoriert z. B. Rabatt-Prozente im Namen). */
    var m = s.match(/(\d+)\s*[-\s]?(woch|week|täg|tag|day|monat|month|jähr|jahr|year)/);
    var num, unit;
    if (m) { num = parseInt(m[1], 10); unit = m[2]; }
    else { num = 1; unit = (s.match(/woch|week|täg|tag|day|monat|month|jähr|jahr|year/) || [])[0] || 'monat'; }
    if (/woch|week/.test(unit)) return Math.max(1, Math.round(num / 4.345));
    if (/täg|tag|day/.test(unit)) return Math.max(1, Math.round(num / 30));
    if (/jähr|jahr|year/.test(unit)) return num * 12;
    return num; /* Monate (monatlich = 1) */
  }

  customElements.define('fembe-subscription', FembeSubscription);
})();
